import { RETRACED_ROLE_KEYS } from '@retracedgmbh/modules/permissions/contracts';

/** Keyed by the real `iam_roles.key` value, not the legacy bucket string. */
export const USER_ROLE_LABELS: Record<string, string> = {
  [RETRACED_ROLE_KEYS.RETRACED_ADMIN]: 'Retraced Admin',
  [RETRACED_ROLE_KEYS.RETRACED_SALES]: 'Retraced Sales',
  [RETRACED_ROLE_KEYS.RETRACED_PRODUCT_DEVELOPMENT]:
    'Retraced Product Development',
  [RETRACED_ROLE_KEYS.RETRACED_CUSTOMER_SUCCESS]: 'Retraced Customer Success',
  [RETRACED_ROLE_KEYS.RETRACED_MARKETING]: 'Retraced Marketing',
};

export const USER_ROLE_OPTIONS = Object.entries(USER_ROLE_LABELS).map(
  ([key, label]) => ({ key, label }),
);

export const RETRACED_ADMIN_COMPANY_ID =
  (import.meta.env.VITE_RETRACED_ADMIN_COMPANY_ID as string | undefined) ?? '';

/**
 * Every internal (staff) role, always offered in the "Create user" picker —
 * the create endpoint itself enforces who may actually assign which one
 * (`couldCreateUserWithRole`/`assignableStaffRoleKeysDb`, server-side), so the
 * picker doesn't pre-filter; an unauthorized pick just gets a 403 on submit.
 * Derived from the canonical `RETRACED_ROLE_KEYS` (`modules/permissions`) so
 * this list can't drift from what the retraced tenant's `iam_roles` actually
 * contains. Uses its values (real `iam_roles.key`s, e.g. `'retraced-admin'`)
 * as the option key — that's what gets sent as `role` on submit.
 */
export const INTERNAL_ROLE_OPTIONS = Object.values(RETRACED_ROLE_KEYS).map(
  key => ({ key, label: USER_ROLE_LABELS[key] ?? key }),
);
